// extracted by mini-css-extract-plugin
export default {"modalForm":"GroupCreateForm_modalForm__pGoL9","selectWrapper":"GroupCreateForm_selectWrapper__ZUVe7","btnSubmit":"GroupCreateForm_btnSubmit__ETKqQ"};